import React from 'react'
import { Badge, Group, Text, ThemeIcon } from '@mantine/core'
import { CalendarEvent, Ticket, User } from 'tabler-icons-react'

const icons = { checkins: Ticket, experiences: CalendarEvent, users: User }

export default function OrgSearchResultContent({ item }) {
	const Icon = icons[item.type] || Ticket
	return (
		<Group spacing='sm' noWrap>
			<ThemeIcon variant='light' color='gray' size={32}><Icon size={17} aria-hidden='true' /></ThemeIcon>
			<div style={{ flex: 1, minWidth: 0 }}>
				<Text size='sm' weight={500} truncate>{item.title}</Text>
				<Text size='xs' color='dimmed' truncate>{item.subtitle}</Text>
			</div>
			<Badge size='xs' color='gray' variant='light' style={{ flexShrink: 0 }}>{item.status}</Badge>
		</Group>
	)
}
